// all basic dependencies
import '../stylesheets/application.scss';
import './lib/bootstrap.min';
import './lib/chartkick';
// import './lib/es5';
// import './lib/es6';
import './lib/jquery.creditCardValidator';
import './lib/jquery-easing.min'; // XXX unused?
// import './lib/jquery.localscroll-1.2.7-min';
import './lib/jquery.scrollTo-1.4.3.1-min';
import './lib/jquery.shuffle'; // used in surveys
import './lib/jquery.typewatch';
import './lib/jquery-ui.1.11.2';
import './lib/jquery.ui.touch-punch.min';
import Mailcheck from './lib/mailcheck.min';
import './lib/plinks';
import './lib/selectize.min';

Object.assign(window, { Mailcheck });
